export default __webpack_public_path__ + "static/media/user-type-1.2f17712b.svg";